var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.58,
    height: 21.206,
    viewBox: "0 0 16.58 21.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6099",
    "data-name": "Group 6099",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M30.324,6.842a.259.259,0,0,0-.259.259V7.8a.259.259,0,1,0,.517,0V7.1a.259.259,0,0,0-.259-.259",
    transform: "translate(-22.283 -5.071)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M14.682,3.181H12.868a1.77,1.77,0,0,0-1.759-1.6h-.641a.579.579,0,0,1-.54-.338,2.053,2.053,0,0,0-3.775,0,.579.579,0,0,1-.54.338H4.971a1.77,1.77,0,0,0-1.759,1.6H1.4A1.4,1.4,0,0,0,0,4.58V19.307a1.4,1.4,0,0,0,1.4,1.4H14.682a1.4,1.4,0,0,0,1.4-1.4V4.58a1.4,1.4,0,0,0-1.4-1.4m-10.961.17A1.252,1.252,0,0,1,4.971,2.1h.641a1.094,1.094,0,0,0,1.015-.651,1.536,1.536,0,0,1,2.825,0,1.094,1.094,0,0,0,1.015.651h.641a1.252,1.252,0,0,1,1.25,1.25v.885H3.721ZM15.563,19.307a.882.882,0,0,1-.881.881H1.4a.882.882,0,0,1-.881-.881V4.58A.882.882,0,0,1,1.4,3.7H3.2v.8a.259.259,0,0,0,.259.259h9.156a.259.259,0,0,0,.259-.259V3.7h1.805a.882.882,0,0,1,.881.881Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M16.028,46.457H12.636a.259.259,0,0,0,0,.518h3.392a.259.259,0,0,0,0-.518",
    transform: "translate(-9.174 -34.433)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M16.028,56.3H12.636a.259.259,0,1,0,0,.518h3.392a.259.259,0,0,0,0-.518",
    transform: "translate(-9.174 -41.729)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M16.028,36.614H12.636a.259.259,0,1,0,0,.518h3.392a.259.259,0,0,0,0-.518",
    transform: "translate(-9.174 -27.137)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M16.028,26.771H12.636a.259.259,0,1,0,0,.518h3.392a.259.259,0,0,0,0-.518",
    transform: "translate(-9.174 -19.842)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M38.3,46.457H34.9a.259.259,0,0,0,0,.518H38.3a.259.259,0,0,0,0-.518",
    transform: "translate(-25.679 -34.433)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M38.3,56.3H34.9a.259.259,0,1,0,0,.518H38.3a.259.259,0,1,0,0-.518",
    transform: "translate(-25.679 -41.729)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16.028,66.291H12.636a.259.259,0,1,0,0,.518h3.392a.259.259,0,0,0,0-.518",
    transform: "translate(-9.174 -49.133)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M38.3,66.291H34.9a.259.259,0,1,0,0,.518H38.3a.259.259,0,1,0,0-.518",
    transform: "translate(-25.679 -49.133)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M38.3,36.614H34.9a.259.259,0,1,0,0,.518H38.3a.259.259,0,1,0,0-.518",
    transform: "translate(-25.679 -27.137)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M38.3,26.771H34.9a.259.259,0,1,0,0,.518H38.3a.259.259,0,1,0,0-.518",
    transform: "translate(-25.679 -19.842)",
    fill: "#fff",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.b4226f14d62a9fbad43eac5965190d8e.svg";
export { ForwardRef as ReactComponent };